<script>import SVG from "../SVG.svelte";
import { attrValue } from "../../../utils/html";
import ButtonText from "../buttons/variants/ButtonText.svelte";
import Input from "./Input.svelte";
export let props;
export let onEndingIconClick = null;
const handleFirstChange = () => {
  if (!props.dirty) {
    props = Object.assign(props, { dirty: true });
  }
};
const handleClear = () => {
  props = Object.assign(props, { value: "" });
  props.ref.focus();
};
const onFocus = () => {
  props.focus = true;
  if (!props.touched) {
    props.touched = true;
  } else if (!props.touchedTwice) {
    props.touchedTwice = true;
  }
};
const onBlur = () => props.focus = false;
$: id = props && props.id;
$: required = props && props.required;
$: disabled = props && props.disabled;
$: placeholder = props && props.placeholder;
$: if (props) {
  props.ref = props && props.ref ? props.ref : null;
}
</script>

<Input bind:props>
	<div class="relative flex">
		<input
			{...$$restProps}
			{id}
			{required}
			{disabled}
			{placeholder}
			autocomplete={props.autocomplete ? 'on' : 'off'}
			name={props.name}
			class={attrValue(['input', props.classNames])}
			class:dirty={props.dirty}
			class:pl-6={props.leadingIcon}
			class:pr-6={props.endingIcon}
			class:disabled={props.disabled}
			class:border-danger-light={props.error}
			class:focus:border-danger={props.error}
			class:border-grey-light={!props.error}
			class:focus:border-secondary={!props.error}
			bind:value={props.value}
			bind:this={props.ref}
			on:input
			on:input|once={() => handleFirstChange()}
			on:focus={() => onFocus()}
			on:focus
			on:blur={() => onBlur()}
			on:keypress
			on:keyup
			on:change
			on:paste
		/>

		{#if props.leadingIcon}
			<SVG
				name={props.leadingIcon}
				classNames={attrValue([
					'transition absolute top-1/2 transform -translate-y-1/2 translate-x-1/2 left-0'
				])}
			/>
		{/if}

		{#if props.endingIcon && !props.withClearAction}
			<SVG
				name={props.endingIcon}
				classNames={attrValue([
					'transition absolute top-1/2 transform -translate-y-1/2 -translate-x-1/2 right-0'
				])}
				on:click={onEndingIconClick}
			/>
		{/if}

		{#if props.withClearAction}
			<ButtonText
				props={{
					size: 'small',
					iconLeft: 'cross',
					tooltip: {
						title: props.clearActionTooltipTitle
					},
					classNames: attrValue([
						props.focus ? 'text-secondary' : 'text-transparent',
						'self-center transition !absolute top-1/2 transform -translate-y-1/2 -translate-x-1/2 right-0'
					])
				}}
				on:click={() => handleClear()}
			/>
		{/if}
	</div>
</Input>
